<!--
Author: TangChen
Date: 2018-09-05
Desc: 登录页面组件，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-register bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <el-row v-if="!checked" class="register">
            <el-col :span="20" :offset="2">
                <el-form
                    ref="ruleForm"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="240px"
                    class="demo-ruleForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item label="手机号码" prop="mobile">
                        <el-row>
                            <el-col>
                                <el-select

                                    v-model="ruleForm.country"
                                    placeholder="请选择国家码"
                                >
                                    <el-option
                                        v-for="item in countrycode"
                                        :key="item.subitem"
                                        style="width:350px"
                                        :label="item.subitemname + ' '+ item.subitem"
                                        :value="item.subitem"
                                        :disabled="true"
                                    />
                                </el-select>
                                <el-input v-model.trim="ruleForm.mobile" style="margin-left:-115px; width: 252px;" placeholder="请输入手机号码" :maxlength="11" />
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="手机验证码" prop="verifyCode" class="verifycode-row">
                        <!-- <el-input
                            v-model.trim="ruleForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input> -->
                        <el-row>
                            <el-col :span="8">
                                <el-input
                                    v-model.trim="ruleForm.verifyCode"
                                    class="verifycode-style"
                                    placeholder="请输入手机验证码"
                                    :maxlength="6"
                                >
                                </el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button
                                    class="get-verify"
                                    :disabled="time>0"
                                    v-on:click="mobileCheck"
                                >
                                    {{ btnMsg }}
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="输入密码" prop="pwd">
                        <el-input
                            v-model.trim="ruleForm.pwd"
                            :type="pwdType"
                            placeholder="请输入登录密码"
                            :maxlength="16"
                        >
                            <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                        </el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPwd">
                        <el-input
                            v-model.trim="ruleForm.confirmPwd"
                            :type="pwdType"
                            placeholder="请再输入一次登录密码"
                            :maxlength="16"
                        >
                            <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                        </el-input>
                    </el-form-item>
                    <el-form-item class="pwd-text">
                        <div class="info" v-text="pwdText"></div>
                    </el-form-item>
                    <el-form-item style="margin-left:-80px">
                        <div class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                            <div style="display: flex; align-items: flex-start;">
                                <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                                <span style="padding-left:5px;line-height:30px;width:623px">
                                    本人已经仔细阅读并同意
                                    <span style="cursor: pointer;text-decoration:none; color: red" v-on:click="showAgreement('agreement_privacyPolicy','隐私政策')">
                                        《隐私政策》
                                    </span>
                                    <span>、</span>
                                    <span style="cursor: pointer;text-decoration:none; color: red" v-on:click="showAgreement('agreement_service','网上交易服务协议')">
                                        《网上交易服务协议》
                                    </span>
                                    相关内容 ，并充分了解
                                    <span style="cursor: pointer;text-decoration:none; color: red" v-on:click="showAgreement('agreement_equity','投资者权益须知')">
                                        《投资者权益须知》
                                    </span>
                                    内容，同意遵照前述法律文件约定执行。
                                </span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item class="margin-top">
                        <el-button type="primary" class="medium" v-on:click="submitForm('ruleForm',true)">
                            确定
                        </el-button>
                        <el-button class="medium" v-on:click="returnLogin('1')">
                            取消
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <div class="login-now">
                            已有账号？
                            <a href="#" v-on:click.once="returnLogin">立即登录</a>
                        </div>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--暂时平屏蔽-->
            <el-col v-if="false" :span="20" :offset="2">
                <div class="register-lead border-top cursor">
                    &gt;&gt;快速注册操作指引
                </div>
            </el-col>
        </el-row>
        <el-row v-if="checked" class="register-result">
            <el-col :span="20" :offset="2">
                <result :result="resultObj" v-on:login-now="eventBtn" v-on:return-login="returnBtn" />
                <span class="like-a had-trade" v-on:click.once="$router.push({name: 'bindoldacct'})">已有交易账号？</span>
                <div v-if="others.length > 0" class="register-other border-top">
                    <span class="register-btn-msg">{{ registerOther }}</span>
                    <div v-if="(others && others.length > 0)" class="register-other-box">
                        <div v-for="list in others" :key="list.id" class="other-list">
                            <img class="other-list-img" :src="require('../../assets/img/'+list.url+'.png')">
                            <span class="other-list-text">{{ list.val }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
        <agreement2 v-model="isShowAgreement" :agrCon="agreementContent" :title="agreementTitle" v-on:all-read="isShowAgreement=false"></agreement2>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import imgCode from "@/components/layout/imgCode.vue";
import Agreement from "@/components/form/agreement.vue";
import agreement2 from "@/components/form/agreement2.vue";
import result from "@/components/layout/result.vue";
import navTips from "@/components/form/navTips.vue";
export default {
    name: "Register",
    components: {
        imgCode,
        Agreement,
        result,
        navTips,
        agreement2
    },
    mixins: [mixin],
    data () {
        return {
            pwdType: "password", // 密码输入框类型
            dialogVisible: false, // 是否显示图片验证码框
            time: 0,
            protocol: false,
            pwdText: "",
            agrType: "register", // 协议类型，注册协议
            ruleForm: {
                mobile: "",
                verifyCode: "",
                pwd: "",
                confirmPwd: "",
                type: "",
                country: "中国+86"
            },
            checked: false, // 是否显示注册结果页
            registerSuccess: false, // 是否注册成功
            titTips: {
                tit: "快速注册",
                text: "一步开通注册账户，快速登录网上交易",
                cla: "register"
            },
            resultObj: {// 结果页面信息
                cla: "register-success",
                msg: "恭喜您，已成功注册账户！",
                btnMsg: "添加一张银行卡，开启您的基金投资之旅",
                btnL: {
                    text: "添加银行卡",
                    event: "login-now"
                },
                btnR: {
                    text: "进入个人中心",
                    event: "return-login"
                }
            },
            // registerOther: "关联第三方账户",
            /*{ id: "1", val: "QQ账号", url: "qq_icon" },*/
            // others: [{ id: "2", val: "微信账号", url: "wx_icon" }],
            others: [],
            readFileInfoList: [
                { textname: "隐私政策", textId: "" },
                { textname: "网上交易服务协议", textId: "" },
                { textname: "投资者权益须知", textId: "" }
            ],
            btnMsg: "获取验证码",
            locked: false, // 是否已发送验证码
            iconCla: "fa fa-eye-slash", // 密码输入框图标
            rules: {
                mobile: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.validateMobile, trigger: "blur" }
                ],
                verifyCode: [
                    { validator: this.$util.validateVerifyCode, trigger: "blur" }
                ],
                pwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ],
                confirmPwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ]
            },
            countrycode: [],
            isShowAgreement: false,
            checkbox: false,// 是否同意相关文件
            agreementContent: "",
            agreementTitle: ""
        };
    },
    mounted(){
        this.$util.initPwdCheckText();
        this.countrycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        document.addEventListener("keydown", this.handleKeyDown);
    },

    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeyDown);
    },
    methods: {
        handleKeyDown(event) {
            if (event.key === "Escape") {
                this.isShowAgreement = false;
            }
        },
        agreePro(val){
            this.protocol = false;
            if(!val)return;
            this.register();
        },
        /* 获取图形验证码值 */
        getVerifyCode (val) {
            this.dialogVisible = false;
            if (val) {
                this.$util.sendSms(this, val, "ruleForm", "acct/register/sendsms");
            }
        },
        /* 确认密码校验 */
        confirm (rule, value, callback) {
            if (this.ruleForm.pwd !== this.ruleForm.confirmPwd && this.ruleForm.pwd !== "" && this.ruleForm.confirmPwd !== "") {
                callback(new Error("输入密码和确认密码不一致"));
            } else {
                callback();
            }
        },
        eventBtn () {
            if (this.registerSuccess) {
                this.$router.push({ name: "bindnewacct" });
            } else {
                this.$router.push({ name: "register" });
            }
        },
        /* 右边按钮事件处理，注册成功跳转到首页，失败跳转到登录 */
        returnBtn () {
            if (this.registerSuccess) {
                this.$router.push({ name: "info" });
            } else {
                this.$router.push({ name: "login" });
            }
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange () {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        /* 提交表单数据 */
        mobileCheck () {
            this.$util.mobileCheck(this, "ruleForm");
        },
        /* 提交表单数据 */
        submitForm (formName) {
            if(!this.checkbox){
                return this.$alert("根据相关法规要求，请在注册前仔细阅读相关文件，并勾选“我已阅读并同意”选项。","提示", {confirmButtonText: "确定"});
            }
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    if (this.locked) {
                        this.protocol = true;
                        return false;
                    }
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 注册 */
        register () {
            let _this = this;
            var newCountry = "";
            if(_this.ruleForm.country == "中国+86"){
                newCountry = "86";
            }
            else{
                newCountry = _this.ruleForm.country;
            }
            const encPwd = this.$util.enc(this.ruleForm.pwd);
            _this.$util.request("acct/register/individual", {
                mobile: _this.ruleForm.mobile,
                loginpwd: encPwd,
                verifycode: _this.ruleForm.verifyCode,
                mobilenocycode: newCountry
            }, "POST").then(res => {
                if (res.data) {
                    _this.$store.dispatch("login", res.data[0]).then(() => {
                        _this.checked = true;
                        _this.registerSuccess = true;
                    });
                } else {
                    this.resultObj = {// 结果页面信息
                        cla: "register-fail",
                        msg: "很抱歉，账户注册失败！！",
                        btnMsg: res.msg ? res.msg : "您的账户信息已超时失效，请您重新注册",
                        btnL: {
                            text: "重新注册",
                            event: "login-now"
                        },
                        btnR: {
                            text: "取消",
                            event: "return-login"
                        }
                    };
                    this.checked = true;
                }
            });
        },
        /* 返回登录页 */
        returnLogin (flag) {
            if (flag === "1") {
                this.$router.go(-1);
                return false;
            }
            this.$router.push("/");
        },
        validateMobile (rule, value, callback) {
            if(this.ruleForm.country == "中国+86" || this.ruleForm.country == "86") {
                this.$util.validateMobile(rule, value, callback);
            }
        },
        showAgreement (agrCon,title) {
            this.agreementContent = agrCon;
            this.agreementTitle = title;
            this.isShowAgreement = true;
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-register {
    .register-lead {
        color: $text-color1;
        font-size: $f18;
        text-align: center;
        line-height: 30px;
        padding: 18px 0 28px 0;
        &:hover {
            color: $color-a;
        }
    }
    .el-row.register {
        padding-top: 35px;
        .el-form-item {
            &.is-required .el-form-item__label:before {
                content: "";
            }
            .el-form-item__label {
                font-size: $f16;
                color: $text-color3;
            }
            .el-input {
                font-size: $f16;
                width: 50%;
                &.verifycode-style {
                    width: 98%;
                }
                .get-verify {
                    color: $color-a;
                    min-width: 140px;
                }
                .el-button.is-disabled {
                    color: $text-color3;
                    background-color: transparent;
                    border-color: transparent;
                }
                .fa {
                    margin-right: 6px;
                }
            }
            .get-verify {
                color: $color-b-o;
                min-width: 100px;
                width: 100%;
            }
            .el-button.is-disabled {
                color: $text-color3;
                background-color: transparent;
            }
            &.verifycode-row {
                >.el-form-item__content>.el-form-item__error {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .el-button + .el-button {
                margin-left: 52px;
            }
            .el-form-item__error--inline {
                color: $color-c;
            }
        }
        .el-form-item.check {
            margin-bottom: 10px;
            .el-checkbox-group {
                height: 40px;
            }
            .el-form-item__error--inline {
                display: block;
            }
        }
    }
    .pwd-text{
        margin-bottom: 0px;
        color: $text-color3;
        .el-form-item__content{
            line-height: 24px;
        }
    }
    .form-text {
        margin-bottom: 10px;
    }
    .el-row.register-result {
        text-align: center;
        padding-top: 35px;
        .had-trade {
            margin-bottom: 20px;
            display: inline-block;
        }
        .register-other {
            padding-bottom: 29px;
            .register-btn-msg {
                color: $text-color1;
                line-height: 30px;
                padding: 19px 0 17px;
                display: block;
            }
            .register-other-box {
                .other-list {
                    margin: 0 20px 0 15px;
                    display: inline-block;
                    .other-list-img {
                        vertical-align: middle;
                    }
                    .other-list-text {
                        color: $text-color3;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
